import { Directive } from '@angular/core';

@Directive({
  selector: '[appResendOtp]'
})
export class ResendOtpDirective {

  constructor() { }

}
